import { startSsoRedirect as startOktaSsoRedirect } from "../OktaSso/startSsoRedirect";
import { startSsoRedirect as startRipplingSsoRedirect } from "../RipplingSso/startSsoRedirect";
import { getActiveSsoProvider, SSO_PROVIDER } from "./activeProvider";

export async function startActiveSsoRedirect(): Promise<void> {
  if (getActiveSsoProvider() === SSO_PROVIDER.OKTA) {
    await startOktaSsoRedirect();
    return;
  }
  await startRipplingSsoRedirect();
}
